import type { ITabletopOrganization } from '~/types/tabletop'

export const GAMESTOP_PARENT_ORGANIZATION_ID = '18147'

export function checkIsGamestopStore(
  store: ITabletopOrganization | undefined,
): boolean {
  if (!store) return false

  return store.parentOrganizationId === GAMESTOP_PARENT_ORGANIZATION_ID
}
